import React from 'react';
import '../styles/DepartmentComments.css';
import imagePlaceholder from '../Assets/Images/images.png';

const heads = [
  {
    name: 'Mr. A. Rahman',
    title: 'Head of Operations',
    comment: 'Focused on streamlining processes for greater efficiency.',
    image: imagePlaceholder,
  },
  {
    name: 'Ms. B. Akter',
    title: 'Head of HR',
    comment: 'Promoting a culture of empathy, growth, and discipline.',
    image: imagePlaceholder,
  },
  {
    name: 'Mr. C. Islam',
    title: 'Head of IT',
    comment: 'Driving digital transformation across departments.',
    image: imagePlaceholder,
  },
  {
    name: 'Mr. D. Rahman',
    title: 'Head of Finance',
    comment: 'Ensuring financial discipline and strategic investments.',
    image: imagePlaceholder,
  },
  {
    name: 'Ms. E. Haque',
    title: 'Head of Marketing',
    comment: 'Building strong brand presence and customer engagement.',
    image: imagePlaceholder,
  },
];

function DepartmentComments() {
  const [current, setCurrent] = React.useState(0);
  const total = heads.length;
  const visibleCards = 3;

  const goNext = () => {
    setCurrent((prev) => (prev + 1 >= total ? 0 : prev + 1));
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 < 0 ? total - 1 : prev - 1));
  };

  const visibleHeads = heads.slice(current, current + visibleCards);
  // Handle case when current + visibleCards > total
  const displayHeads =
    visibleHeads.length < visibleCards
      ? [...visibleHeads, ...heads.slice(0, visibleCards - visibleHeads.length)]
      : visibleHeads;

  return (
    <div className="department-section" id="team">
      <div className="department-header">
        <h2 className="section-title">MEET OUR LEADERSHIP TEAM</h2>
        <div className="department-nav">
          <button className="nav-btn" onClick={goPrev}>&larr;</button>
          <button className="nav-btn" onClick={goNext}>&rarr;</button>
        </div>
      </div>

      <div className="comments-wrapper">
        {displayHeads.map((head, index) => (
          <div className="comment-card-wrapper" key={index}>
            <div className="comment-card">
              <div className="image-frame">
                <img src={head.image} alt={head.name} />
              </div>
              <h3 className="name">{head.name}</h3>
              <p className="title">{head.title}</p>
              <p className="comment">{head.comment}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DepartmentComments;
